import Highlight from "../components/Highlight";
import img01 from "../images/about_001.jpeg";
import img02 from "../images/about_002.jpeg";
import img03 from "../images/about_004.jpeg";

const About = () => (
  <>
    <Highlight img="about" size="small" />
    <div className="flex flex-col">
      <p className="text-gray-500 p-8">
        A ONE IDEA, é uma empresa portuguesa com sede na Praia de Miramar, Vila
        Nova de Gaia. Somos uma equipa jovem, mas com mais de 50 anos de
        experiência acumulada no mercado de Mobiliário de Cozinha. Dominamos
        todos os detalhes desde a seleção dos materiais, fornecedores, gestão de
        produção, projeto e instalação, mas sem deixar de dar uma atenção muito
        especial e particular ao entendimento das ideias do cliente.
        <br />
        Dedicamo-nos a conceber, projetar, produzir e instalar as suas ideias!
      </p>

      <div className="flex">
        <div className="w-1/2 overflow-hidden flex h-80">
          <img src={img01} alt="" className="object-cover w-full" />
        </div>
        <div className="flex-1 p-8">
          <h2 className="text-2xl font-bold mb-4">Conceção</h2>
          <p className="text-gray-500 mb-6">
            ONE IDEA! Partimos da sua ideia… á procura de conceber as soluções
            possíveis! Interpretar e traduzir as vontades e ideias do cliente,
            para um projeto que seja sustentável. Mantendo o foco na vontade do
            cliente, evoluímos para as soluções disponíveis, oferecendo um vasto
            leque de possibilidades no caminho até á solução final.
          </p>
        </div>
      </div>

      <div className="flex">
        <div className="flex-1 p-8">
          <h2 className="text-2xl font-bold mb-4">Projeto</h2>
          <p className="text-gray-500 mb-6">
            A One Idea dedica uma atenção especial á preparação técnica da ideia
            concebida com o cliente. Todos os pormenores são considerados,
            tentando prever e prevenir qualquer dificuldade, na procura de
            realizar tudo com o maior detalhe possível.
          </p>
        </div>
        <div className="w-1/2 overflow-hidden flex h-80">
          <img src={img02} alt="" className="object-cover w-full" />
        </div>
      </div>

      <div className="flex">
        <div className="w-1/2 overflow-hidden flex h-80">
          <img src={img03} alt="" className="object-cover w-full" />
        </div>
        <div className="flex-1 p-8">
          <h2 className="text-2xl font-bold mb-4">Produção e Instalação</h2>
          <p className="text-gray-500 mb-6">
            E agora vamos produzir, garantindo os materiais mais apropriados,
            sendo rigorosos e exigentes na qualidade do produto. O prazo é
            importante, e a garantia do resultado perfeito. Vamos instalar com
            todo o cuidado e carinho que a sua cozinha merece e precisa.
          </p>
        </div>
      </div>
    </div>
  </>
);

export default About;
